import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { patchTransactionCancel } from "../api";

export const useCancelTransaction = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();

  // Gunakan useMutation untuk meng-handle request PATCH
  const { mutate, isPending } = useMutation({
    mutationFn: patchTransactionCancel, // Fungsi API yang diimport
    onSuccess: () => {
      // Refetch data setelah transaksi berhasil dibatalkan
      queryClient.refetchQueries({ queryKey: ["TRANSACTION"] });

      // Arahkan ke halaman list transaksi
      router("/order-list");

      // Tampilkan toast sukses
      toast.success("Transaksi berhasil dibatalkan!");
    },
    onError: (error: any) => {
      // Tangani jika ada error
      toast.error(`Gagal membatalkan transaksi: ${error.message}`);
    },
  });

  return { cancelTransaction: mutate, isPending };
};
